import styled from "styled-components";

const StyledMissingModal = styled.div`
  .missing-product-checkboxes {
    display: flex;
    gap: 10px;
    width: 100%;
    margin-top: 20px;
    overflow: hidden;
    .form-group {
      flex: 1;
      .check-group {
        flex: 1;
        margin: 0;
        padding: 0;
        input:checked + label{
          background-color: rgba(255, 184, 34, 1);

        }
        label {
          border-radius: 10px;

          padding: 10px;
          margin: 0;
          border: 2px solid rgba(255, 184, 34, 0.7);
          color: #000;
          text-align: center;
          &::before,
          &::after {
            display: none;
          }
        }
      }
    }
  }
`;

export default StyledMissingModal;
